export { AuthProfileType, FboProfileTypeId } from '@procom-labs/bridge';
export var AuthSignupType = /*#__PURE__*/ function(AuthSignupType) {
    AuthSignupType["Email"] = "email";
    AuthSignupType["Social"] = "social";
    return AuthSignupType;
}({});
export var FboUrlTypeId = /*#__PURE__*/ function(FboUrlTypeId) {
    FboUrlTypeId[FboUrlTypeId["TimesheetDetail"] = 1] = "TimesheetDetail";
    FboUrlTypeId[FboUrlTypeId["ExpenseDetail"] = 2] = "ExpenseDetail";
    FboUrlTypeId[FboUrlTypeId["CreateExpense"] = 3] = "CreateExpense";
    return FboUrlTypeId;
}({});
export var FboActivationStatus = /*#__PURE__*/ function(FboActivationStatus) {
    FboActivationStatus["Completed"] = "Completed";
    FboActivationStatus["Failed"] = "Failed";
    FboActivationStatus["Skipped"] = "Skipped";
    FboActivationStatus["Pending"] = "Pending";
    FboActivationStatus["Processing"] = "Processing";
    return FboActivationStatus;
}({});
export var DomainDetectionErrors = /*#__PURE__*/ function(DomainDetectionErrors) {
    DomainDetectionErrors["ClientSignupNotAllowed"] = "ClientSignupNotAllowed";
    DomainDetectionErrors["ClientCreateNotAllowed"] = "ClientCreateNotAllowed";
    return DomainDetectionErrors;
}({});
